import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import {
  insertLearningContinuum as insertLearningContinuumService,
  removeLearningContinuum as removeLearningContinuumService,
} from "../../services/developmental-rubrics/learning-continuum.service";
import { useParams } from "react-router-dom";
import useDevelopmentalRubrics from "./useDevelopmentalRubrics";
import { useState } from "react";
import { updateDevelopmentalRubricFormError } from "../../store/actions/developmental-rubrics.actions";
import { toggleAlertInfo, toggleAlertModule } from "../../store/actions/alert.actions";
import { handlerErrorV2 } from "../../utils/errors";

const useLearningContinuum = () => {
  const { curriculumId, id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { getDevelopmentalRubricById } = useDevelopmentalRubrics();
  const [isLoading, setIsLoading] = useState(false);

  const insertLearningContinuum = async (lcs) => {
    setIsLoading(true);
    try {
      dispatch(
        toggleAlertInfo(
          true,
          "Inserting Learning continuum",
          "Please wait as this may take a few minutes",
          "loading"
        )
      );
      const response = await insertLearningContinuumService(curriculumId, id, {
        lcs,
      });
      if (!response.data && response.error) {
        dispatch(updateDevelopmentalRubricFormError(response.error.message || "An error ocurred",));
      } else {
        dispatch(toggleAlertModule());
        getDevelopmentalRubricById(curriculumId, id);
        enqueueSnackbar("Developmental rubric linked successfully", {
          variant: "success",
        });
        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      dispatch(updateDevelopmentalRubricFormError(message));
    } finally {
      setIsLoading(false);
      dispatch(toggleAlertInfo(false));
    }
  };

  const removeLearningContinuum = async (lcs) => {
    setIsLoading(true);
    try {
      dispatch(
        toggleAlertInfo(
          true,
          "Removing Learning continuum",
          "Please wait as this may take a few minutes",
          "loading"
        )
      );
      const response = await removeLearningContinuumService(curriculumId, id, {
        lcs: lcs.map((lc) => lc._id),
      });
      if (!response.data && response.error) {
        dispatch(updateDevelopmentalRubricFormError(response.error.message || "An error ocurred",));
      } else {
        getDevelopmentalRubricById(curriculumId, id);
        dispatch(toggleAlertModule());
        enqueueSnackbar("Developmental rubric linked successfully", {
          variant: "success",
        });
        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      dispatch(updateDevelopmentalRubricFormError(message));
    } finally {
      setIsLoading(false);
      dispatch(toggleAlertInfo(false));
    }
  };

  return {
    isLoading,
    insertLearningContinuum,
    removeLearningContinuum,
  };
};

export default useLearningContinuum;
